"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var estiloLabel = require('./Label.module.scss');
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Label = function (_a) {
    var _b = _a.texto, texto = _b === void 0 ? 'Label' : _b, estado = _a.estado, desabilitado = _a.desabilitado, obrigatorio = _a.obrigatorio, htmlFor = _a.htmlFor, negrito = _a.negrito, corObrigatorio = _a.corObrigatorio;
    var _c = react_1.default.useState(Cores_1.Cores.TextoPadrao.CinzaMU600), cor = _c[0], setCor = _c[1];
    (0, react_1.useEffect)(function () {
        if (desabilitado) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        }
        else {
            if (estado === 'regular') {
                setCor(Cores_1.Cores.TextoPadrao.CinzaMU600);
            }
            else if (estado === 'error') {
                setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
            }
            else if (estado === 'success') {
                setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
            }
        }
    }, [estado, desabilitado]);
    return (react_1.default.createElement("label", { htmlFor: htmlFor, className: "".concat(estiloLabel.container, " ").concat(desabilitado ? estiloLabel.desabilitado : '') },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", cor: cor, negrito: negrito || 400 }, texto),
        obrigatorio && react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", cor: desabilitado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU400 : corObrigatorio || Cores_1.Cores.MensagensDoSistema.VermelhoMU, negrito: 700 }, "*")));
};
exports.Label = Label;
